import React from 'react'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import { useMerchant } from '@contexts/admin/MerchantContext'
import ListPageHeader from '@shared/ListPageHeader'
import ShipmentsList from '@shared/shipments/ShipmentsList'

import { shipmentService } from '@services/admin/shipmentService'

export default function AdminShipmentsList() {
  const { addJob } = useAdminNotification()
  const { shippingTypes } = useMerchant()

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['shipments', 'shipments.list']}
      />
      <ShipmentsList
        role="admin"
        service={shipmentService}
        shippingTypes={shippingTypes}
        addJob={addJob}
      />
    </div>
  )
}
